import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { ExpandMore } from '@mui/icons-material';
import React, { useState } from 'react';
import { FormikProps } from 'formik';

import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { typesDestinationFormData } from 'system/pages/type-destination/list/types';

interface Props {
  filterTypeDestinationForm: FormikProps<typesDestinationFormData>;
}

const TypeDestinationFilters = ({ filterTypeDestinationForm }: Props): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);
  return (
    <>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-townhalls-content"
          id="panel-townhalls-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={filterTypeDestinationForm.handleSubmit}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="Codice"
                  label="Codice"
                  id="code"
                  name="code"
                  value={filterTypeDestinationForm.values.code}
                  onChange={filterTypeDestinationForm.handleChange}
                  helperText={filterTypeDestinationForm.values.code}
                  error={
                    Boolean(filterTypeDestinationForm.errors.code) &&
                    filterTypeDestinationForm.touched.code
                  }
                  fullWidth
                  type="text"
                  variant="outlined"
                  inputProps={{
                    maxLength: '2',
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="Descrizione zona"
                  label="Descrizione"
                  id="description"
                  value={filterTypeDestinationForm.values.description}
                  error={
                    Boolean(filterTypeDestinationForm.errors.description) &&
                    filterTypeDestinationForm.touched.description
                  }
                  helperText={filterTypeDestinationForm.errors.description}
                  onChange={filterTypeDestinationForm.handleChange}
                  name="description"
                  fullWidth
                  type="text"
                  variant="outlined"
                  inputProps={{
                    maxLength: '20',
                  }}
                />
              </Grid>
              <Grid item xs>
                <PmiButton variant="contained" color="secondary" type="submit">
                  Cerca
                </PmiButton>
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

TypeDestinationFilters.displayName = 'Type Destination filter form component';
export default TypeDestinationFilters;
